import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';

import { isEmptyObject } from '../utils/utils';

import Transfer from '../pages/Transfer';
import Loading from '../components/Loading/Loading';
import NotFoundPage from '../components/NotFound/NotFoundPage';
import { IGNORE_ERROR } from '../constants/constants';
import { withErrorBoundary } from '../components/HOC/ErrorBoundaryHOC';

export function withPermission(WrappedComponent, withErrorBound = true) {
  class WithPermission extends React.PureComponent {
    RenderWrappedComponent = withErrorBound
      ? withErrorBoundary(!IGNORE_ERROR)(WrappedComponent)
      : WrappedComponent;

    // implement logic here
    isAllow = () => {
      const { app, location } = this.props;
      const { restaurants, merchantTableInfos, nowPortalMetadata } = app;
      const { pathname } = location;
      const pathNamePrefix = pathname.split('/')[1];
      if (
        isEmptyObject(restaurants) &&
        ['order', 'ship', 'staff'].includes(pathNamePrefix)
      ) {
        return false;
      } else if (
        isEmptyObject(merchantTableInfos) &&
        ['table'].includes(pathNamePrefix)
      ) {
        return false;
      } else if (
        isEmptyObject(restaurants) &&
        ['/merchant-wallet/wallet-management'].includes(pathname)
      ) {
        return false;
      } else if (isEmptyObject(nowPortalMetadata) &&
        ['/merchant-wallet/history', '/merchant-wallet/withdraw'].includes(pathname)
      ) {
        return false;
      }
      return true;
    };

    isTransfer = () => {
      const { location, currentRestaurant } = this.props;

      const isReport = [
        '/order/report-restaurant', 
        '/order/report-dish',
        '/order/export-restaurant',
      ].includes(location.pathname);
      if (isReport) {
        return false
      }

      return get(currentRestaurant, 'is_use_partner_app', false);
    };

    render() {
      const { app, isRenderNotFound } = this.props;
      const mIsRenderNotFound = isRenderNotFound !== false;
      if (!app.isReady) {
        return <Loading loading />;
      }
      if (this.isAllow()) {
        if (this.isTransfer()) {
          return <Transfer />
        }

        const { RenderWrappedComponent } = this;
        return <RenderWrappedComponent {...this.props} />;
      }
      if (mIsRenderNotFound) {
        return <NotFoundPage />;
      }
      return null;
    }
  }

  function mapStateToProp(state) {
    return {
      auth: state.auth,
      app: state.app,
      currentRestaurant: state.setting.currentRestaurant,
    };
  }

  return withRouter(connect(mapStateToProp)(WithPermission));
}



// WEBPACK FOOTER //
// ./foody/src/authentication/AuthHOC.jsx